import { pitfalls } from "@/mocks/dashan";

const toneStyle: Record<string, string> = {
  劝退: "bg-primary-100 text-primary-700",
  减分: "bg-accent-100 text-accent-800",
  致命: "bg-secondary-200 text-secondary-900",
};

export default function Pitfalls() {
  return (
    <section id="pitfalls" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
              <i className="ri-flag-line"></i> 避坑雷区
            </span>
            <h3 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              这些雷，踩一次就社死
            </h3>
            <p className="mt-3 text-foreground-600 max-w-2xl leading-relaxed">
              与其学一堆花哨开场，不如先躲开最常见的翻车操作。避开雷区，你就已经赢过一半人了。
            </p>
          </div>
          <div className="inline-flex items-center gap-1.5 text-xs text-foreground-500 bg-secondary-100 text-secondary-900 px-3 py-1.5 rounded-full w-fit">
            <i className="ri-error-warning-line"></i> 来自真实聊天记录反馈
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {pitfalls.map((p) => (
            <article
              key={p.title}
              className="rounded-2xl border border-background-200 bg-background-100/40 p-5 md:p-6 flex gap-4 hover:border-background-300 transition-colors"
            >
              <span className="shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-full bg-background-50 border border-background-200 flex items-center justify-center text-primary-600">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <div>
                <div className="flex items-center gap-2 flex-wrap">
                  <h4 className="font-medium text-foreground-950">{p.title}</h4>
                  <span
                    className={`px-2 py-0.5 rounded-full text-[11px] ${toneStyle[p.tone]}`}
                  >
                    {p.tone}
                  </span>
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {p.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}